module.exports = __webpack_public_path__ + "img/qlik.78152ffa.svg";